import { render } from "./ReservationDetails.vue?vue&type=template&id=75d4ffa0&scoped=true"
import script from "./ReservationDetails.vue?vue&type=script&lang=js"
export * from "./ReservationDetails.vue?vue&type=script&lang=js"

import "./ReservationDetails.vue?vue&type=style&index=0&id=75d4ffa0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75d4ffa0"]])

export default __exports__